import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VTooltip,
    {
      attrs: { top: "", "max-width": "300" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "div",
                _vm._g(_vm._b({}, "div", attrs, false), on),
                [
                  _vm.shape === "square"
                    ? _c(
                        "div",
                        {
                          staticClass: "custom-indicator square-indicator",
                          style: _vm.customStyle,
                        },
                        [_c("strong", [_vm._v(_vm._s(_vm.formattedNumber))])]
                      )
                    : _vm.shape === "pill"
                    ? _c(
                        "div",
                        {
                          staticClass: "custom-indicator pill-indicator",
                          style: _vm.customStyle,
                        },
                        [_c("strong", [_vm._v(_vm._s(_vm.formattedNumber))])]
                      )
                    : _c(
                        VAvatar,
                        {
                          staticClass: "circle-indicator",
                          class: {
                            "white--text":
                              !_vm.textColor || _vm.textColor === "white",
                          },
                          attrs: { color: _vm.bgColor, size: "24" },
                        },
                        [
                          _c(
                            "strong",
                            { style: { color: _vm.textColor || "white" } },
                            [_vm._v(_vm._s(_vm.formattedNumber))]
                          ),
                        ]
                      ),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [_vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.tooltipMessage))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }